/* Tenkara Fishing Tips — article reading aids.
   - Builds the "In this article" outline from the post's headings (H2/H3; H4 when there are no H2/H3)
   - Highlights the section being read and shows a reading progress bar
   - Tidies legacy markup imported from WordPress: empty paragraphs, fixed-size video embeds */
(function () {
  if (window.TenkaraJournal) return;
  window.TenkaraJournal = true;

  function slug(text, used) {
    var base = (text || '').toLowerCase().replace(/[^a-z0-9\s-]/g, '').trim().replace(/\s+/g, '-').slice(0, 60) || 'section';
    var s = base, i = 2;
    while (used[s]) s = base + '-' + i++;
    used[s] = true;
    return s;
  }

  function tidy(body) {
    // Empty paragraphs left by the old editor
    body.querySelectorAll('p').forEach(function (p) {
      if (!p.querySelector('img, iframe, video, embed, object') && !p.textContent.replace(/ /g, ' ').trim()) p.remove();
    });
    // Legacy pseudo-headings: a short paragraph that is only bold text becomes a real heading
    body.querySelectorAll('p').forEach(function (p) {
      if (p.querySelector('a, img, iframe, br + *')) return;
      var text = p.textContent.replace(/\u00a0/g, ' ').trim();
      if (text.length < 3 || text.length > 90 || /[.!,;:]$/.test(text)) return;
      var strong = p.querySelector('strong, b');
      if (!strong || strong.textContent.replace(/\u00a0/g, ' ').trim() !== text) return;
      var h = document.createElement('h3');
      h.className = 'jr-body__subhead';
      h.textContent = text;
      p.replaceWith(h);
    });
    // Responsive video embeds
    body.querySelectorAll('iframe').forEach(function (f) {
      var src = f.getAttribute('src') || '';
      if (!/youtube|youtu\.be|vimeo|facebook\.com\/plugins\/video/.test(src)) return;
      if (f.parentElement && f.parentElement.classList.contains('jr-embed')) return;
      var w = document.createElement('div');
      w.className = 'jr-embed';
      f.parentNode.insertBefore(w, f);
      w.appendChild(f);
      f.removeAttribute('width');
      f.removeAttribute('height');
      if (!f.getAttribute('loading')) f.setAttribute('loading', 'lazy');
    });
    // Images: let CSS size them
    body.querySelectorAll('img').forEach(function (img) {
      img.removeAttribute('height');
      if (!img.getAttribute('loading')) img.setAttribute('loading', 'lazy');
    });
  }

  function buildToc(body) {
    var nav = document.querySelector('[data-jr-toc]');
    if (!nav) return [];
    var min = parseInt(nav.dataset.min || '3', 10);
    var heads = body.querySelectorAll('h2, h3');
    heads = Array.prototype.filter.call(heads, function (h) { return h.textContent.trim().length > 1; });
    if (heads.length < min) return [];
    var list = nav.querySelector('[data-jr-toc-list]');
    var used = {};
    var topLevel = heads[0].tagName;
    heads.forEach(function (h) {
      if (!h.id) h.id = slug(h.textContent, used);
      var li = document.createElement('li');
      li.className = 'jr-toc__item' + (h.tagName !== topLevel ? ' jr-toc__item--sub' : '');
      var a = document.createElement('a');
      a.href = '#' + h.id;
      a.textContent = h.textContent.trim();
      li.appendChild(a);
      list.appendChild(li);
    });
    nav.hidden = false;
    var layout = nav.closest('.jr-article__layout');
    if (layout) layout.classList.add('has-toc');
    // Collapsed by default on small screens
    var details = nav.querySelector('[data-jr-toc-details]');
    if (details && window.matchMedia('(max-width: 1199px)').matches) details.open = false;
    list.addEventListener('click', function (e) {
      var a = e.target.closest('a');
      if (!a) return;
      if (details && window.matchMedia('(max-width: 1199px)').matches) details.open = false;
    });
    return heads;
  }

  function init() {
    var body = document.querySelector('[data-jr-body]');
    if (!body) return;
    tidy(body);
    var heads = buildToc(body);
    var links = Array.prototype.slice.call(document.querySelectorAll('[data-jr-toc-list] a'));
    var bar = document.querySelector('[data-jr-progress]');
    var ticking = false;

    function update() {
      ticking = false;
      var rect = body.getBoundingClientRect();
      var total = body.offsetHeight - window.innerHeight * 0.6;
      var done = Math.min(1, Math.max(0, -rect.top / Math.max(total, 1)));
      if (bar) bar.style.transform = 'scaleX(' + done + ')';
      if (heads.length) {
        var active = -1, offset = 140;
        for (var i = 0; i < heads.length; i++) { if (heads[i].getBoundingClientRect().top - offset <= 0) active = i; else break; }
        links.forEach(function (l, i) { l.classList.toggle('is-active', i === active); });
      }
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
